import React from 'react'
import { Env } from '@morningtrain/helpers'
import { useOnNavigate, useRouter } from '@morningtrain/react-navigation'
import * as Auth from '@morningtrain/react-auth'
import MenuItemContext from 'widgets/navigation/MenuItemContext'
import { SidebarMenuItems } from 'ui/navigation'
import MenuItem from 'widgets/navigation/MenuItem'
import useMenu from 'widgets/navigation/use-menu'
import { uniqueId } from 'lodash'

function MenuItems (props) {
  const router = useRouter()

  const menu = useMenu()

  const uuidRef = React.useRef(uniqueId())

  React.useEffect(() => {
    const disposer = menu.addMenu(uuidRef.current, (active) => setIsActive(active))

    return () => disposer()
  }, [])

  const isRouteActive = (route) => {
    const parent = Env.get('page.parent')
    const currentPageParents = Env.get('page.parents', [])

    if (route && route === parent) {
      return true
    }

    if (currentPageParents.length > 0) {
      let anyParentIsActive = false

      currentPageParents.forEach(parent => {
        if (parent && parent.route && parent.route === route) {
          anyParentIsActive = true
        }
      })

      if (anyParentIsActive) {
        return true
      }
    }

    return route === router.currentRoute
  }

  const hasLink = !!props.route

  const checkIfActive = () => {
    if (props.route && isRouteActive(props.route)) {
      return true
    }

    return hasActiveChildren()
  }

  const hasActiveChildren = () => {
    const children = React.Children.toArray(props.children)

    if (children.length === 0) {
      return false
    }

    for (let i = 0; i < children.length; i++) {
      const child = children[i]

      if (!child.props) {
        continue
      }

      if (child.props.route && isRouteActive(child.props.route)) {
        return true
      }
    }

    return false
  }

  const label = () => {
    if (props.label) {
      return props.label
    }

    if (hasLink) {
      const fragments = ('resources.' + props.route).split('.')
      const last = fragments.pop()
      return Env.get([...fragments, 'operations', last, 'title'].join('.'))
    }

    return props.label
  }

  const [isActive, setIsActive] = React.useState(checkIfActive())

  useOnNavigate(() => {
    setIsActive(checkIfActive())
  })

  React.useEffect(() => {
    const disposer = menu.onActiveMenuChange((uuid, isActive) => {
      if (uuid !== uuidRef.current) {
        setIsActive(false)
      }
    })

    return () => {
      disposer()
    }
  }, [menu])

  const SubMenu = (
    props.children && isActive
      ? (
        <MenuItemContext.Provider value={this}>
          <div className={'sidebar-submenu' + (isActive ? '' : ' hidden')}>
            {props.children}
          </div>
        </MenuItemContext.Provider>
        )
      : null
  )

  const handleOnClick = e => {
    e.preventDefault()
    e.stopPropagation()

    setIsActive(!isActive)
    menu.setActive(uuidRef.current)
  }

  const Item = (
    <SidebarMenuItems active={isActive} onClick={handleOnClick}>
      <MenuItem route={props.route} label={label()} active={isActive} svgIcon={props.svgIcon} />
      {SubMenu}
    </SidebarMenuItems>
  )

  if (props.route) {
    return (
      <Auth.Can permission={props.route}>
        {Item}
      </Auth.Can>
    )
  }

  return Item
}

export default MenuItems
